var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"col-sm-2\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ng-click=\"$ctrl.goToAll()\" ui-sref=\"vault.all\">\n<a translate=\"vault.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"vault.create\">\n<a translate=\"vault.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="vault.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/vault/vault.html
// module id = 2890
// module chunks = 1